import { Component } from '@angular/core';

@Component({
  selector: 'app-topbar-search-modal',
  imports: [],
  templateUrl: './topbar-search-modal.component.html',
  styleUrl: './topbar-search-modal.component.scss'
})
export class TopbarSearchModalComponent {

}
